export const QUESTIONNAIRE_REGULAR_CODE = 'meddibaby_regular_inspection';
export const QUESTIONNAIRE_ENTRY_CODE = 'meddibaby_entry_questionnaire';
